import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root'
})
export class PromotionalCodesHttpService extends BaseHttpService {

  private baseURL = `promotional-codes`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  private buildQuery(params: { page?: number; size?: number; code?: string; active?: boolean }): string {
    const parts: string[] = [];
    if (params.page !== undefined) parts.push(`page=${params.page}`);
    if (params.size !== undefined) parts.push(`size=${params.size}`);
    if (params.code !== undefined && params.code !== '') parts.push(`code=${encodeURIComponent(params.code)}`);
    if (params.active !== undefined) parts.push(`active=${params.active}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
  }

  public getPromotionalCodes(page?: number, size?: number, code?: string, active?: boolean) {
    const query = this.buildQuery({ page, size, code, active });
    const url = this.routerService.mount(`${this.baseURL}${query}`);
    return this.read(url);
  }

  public getPromotionalCode(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.read(url);
  }

  public createPromotionalCode(body: any) {
    const url = this.routerService.mount(this.baseURL);
    return this.create(body, url);
  }

  public updatePromotionalCode(id: number, body: any) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.update(body, url);
  }

  public deactivatePromotionalCode(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}/deactivate`);
    return this.update({}, url);
  }

  public activatePromotionalCode(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}/activate`);
    return this.update({}, url);
  }
}
